import { DataRow, ExportTableDataProps } from "@/src/common/types"
import { format } from "date-fns"
import React from "react"

const ExportTableData: React.FC<ExportTableDataProps> = ({ data }) => {
  const currentDate = format(new Date(), "EEEE, MMMM d, yyyy")
  const csvTitle = `Stears-NGN-FX-Rates-${currentDate}`
  const convertToCSV = (data: DataRow[]): string => {
    if (data.length === 0) return ""

    const headers = Object.keys(data[0])
    const csvRows = [
      headers.join(","),
      ...data.map((row) =>
        headers
          .map((fieldName) => JSON.stringify(row[fieldName], replacer))
          .join(",")
      )
    ]
    return csvRows.join("\n")
  }

  const downloadCSV = (): void => {
    if (!data || data.length === 0) return

    const csv = convertToCSV(data)
    const blob = new Blob([csv], { type: "text/csv" })
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = csvTitle
    a.click()
    URL.revokeObjectURL(url)
  }

  const replacer = (key: string, value: string | number | null): string =>
    value === null ? "" : String(value)

  return (
    <button
      onClick={downloadCSV}
      className="border-[0.5px] px-5 py-2.5 dark:border-[#4B5563] dark:bg-[#1A1D21] text-white text-xs font-normal"
    >
      Export
    </button>
  )
}

export default ExportTableData
